import * as React from "react";
/**
 * Represents an info section component
 */ export function InfoSection({ title, description }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "infoSection",
        tabIndex: 0,
        "aria-label": description
    }, /*#__PURE__*/ React.createElement("div", {
        className: "title"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "description"
    }, description));
}
